"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _DialogHandler = _interopRequireDefault(require("../../handlers/DialogHandler"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _OverlayHandler = _interopRequireDefault(require("../../handlers/OverlayHandler"));
var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Overlay = /*#__PURE__*/function (_Component) {
  function Overlay(props) {
    var _this;
    _classCallCheck(this, Overlay);
    _this = _callSuper(this, Overlay, [props]);
    _defineProperty(_this, "overlayDefinition", null);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.setNewState = _this.setNewState.bind(_this);
    _this.setStateFromProps = _this.setStateFromProps.bind(_this);
    _this.isShowing = _this.isShowing.bind(_this);
    _this.overlayDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }
  _inherits(Overlay, _Component);
  return _createClass(Overlay, [{
    key: "show",
    value: function show() {
      var _this2 = this;
      setTimeout(function () {
        if (_DialogHandler["default"].isShowing()) {
          _DialogHandler["default"].hide();
        }
        if (_index.TaskBarHandler.isShowing()) {
          _index.TaskBarHandler.hide();
        }
        _this2.setState({
          display: true
        });
      }, this.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      setTimeout(function () {
        if (_DialogHandler["default"].isShowing()) {
          _DialogHandler["default"].hide();
        }
        if (_index.TaskBarHandler.isShowing()) {
          _index.TaskBarHandler.hide();
        }
        _this3.setState({
          display: false
        });
        callback();
      }, this.state.hideAfter);
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.setState(this.setStateFromProps(state), function () {
        callback();
      });
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var nextProps = props || {};
      var definition = this.overlayDefinition || {};
      var newState = {
        display: this.state ? this.state.display : nextProps.display,
        type: nextProps.type || definition.type || "default",
        className: nextProps.className || definition.className || "",
        style: nextProps.style || definition.style || null,
        content: nextProps.content || definition.content || null,
        title: nextProps.title || definition.title || null,
        hideAfter: nextProps.hideAfter || definition.hideAfter || 0,
        showAfter: nextProps.showAfter || definition.showAfter || 0,
        closeText: nextProps.closeText || definition.closeText || "Close",
        onClose: nextProps.onClose || definition.onClose || null
      };
      return newState;
    }
  }, {
    key: "render",
    value: function render() {
      var _title$leftPanel,
        _title$leftPanel2,
        _title$leftPanel3,
        _content,
        _title$rightPanel,
        _title$rightPanel2,
        _title$rightPanel3,
        _this4 = this,
        _content2;
      var classes = (0, _classnames["default"])("overlay-component", this.state.className, this.state.type, {
        "show": this.state.display
      });
      var content = this.state.content;
      var title = this.state.title || {};
      if (this.state.type === "split") {
        if (content) {
          if (_typeof(content) === "object" && Array.isArray(content)) {
            content = {
              left: content[0] !== undefined ? content[0] : "",
              right: content[1] !== undefined ? content[1] : ""
            };
          } else if (_typeof(content) === "object" && (content.left !== undefined || content.right !== undefined)) {
            content = {
              left: content.left !== undefined ? content.left : "",
              right: content.right !== undefined ? content.right : ""
            };
          } else {
            content = {
              left: content,
              right: ""
            };
          }
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "overlay-component",
        className: classes,
        style: this.state.style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "overlayOverlay"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "overlayContentContainer"
      }, this.state.type === "split" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, (title === null || title === void 0 ? void 0 : title.leftPanel) && /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
        left: title === null || title === void 0 || (_title$leftPanel = title.leftPanel) === null || _title$leftPanel === void 0 ? void 0 : _title$leftPanel.left,
        middle: title === null || title === void 0 || (_title$leftPanel2 = title.leftPanel) === null || _title$leftPanel2 === void 0 ? void 0 : _title$leftPanel2.middle,
        right: title === null || title === void 0 || (_title$leftPanel3 = title.leftPanel) === null || _title$leftPanel3 === void 0 ? void 0 : _title$leftPanel3.right
      }), (_content = content) === null || _content === void 0 ? void 0 : _content.left), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
        left: title === null || title === void 0 || (_title$rightPanel = title.rightPanel) === null || _title$rightPanel === void 0 ? void 0 : _title$rightPanel.left,
        middle: title === null || title === void 0 || (_title$rightPanel2 = title.rightPanel) === null || _title$rightPanel2 === void 0 ? void 0 : _title$rightPanel2.middle,
        right: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title === null || title === void 0 || (_title$rightPanel3 = title.rightPanel) === null || _title$rightPanel3 === void 0 ? void 0 : _title$rightPanel3.right, /*#__PURE__*/_react["default"].createElement(_index.Button, {
          className: "overlayCloseBtn",
          text: this.state.closeText,
          shapeStyle: "fill",
          radius: "square",
          colorTheme: "grey",
          size: "small",
          onClick: function onClick() {
            _OverlayHandler["default"].hide();
            if (_this4.state.onClose) {
              _this4.state.onClose();
            }
          }
        }))
      }), (_content2 = content) === null || _content2 === void 0 ? void 0 : _content2.right)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title && /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
        left: title === null || title === void 0 ? void 0 : title.left,
        middle: title === null || title === void 0 ? void 0 : title.middle,
        right: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title === null || title === void 0 ? void 0 : title.right, /*#__PURE__*/_react["default"].createElement(_index.Button, {
          className: "overlayCloseBtn",
          text: this.state.closeText,
          shapeStyle: "fill",
          radius: "square",
          colorTheme: "grey",
          size: "small",
          onClick: function onClick() {
            _OverlayHandler["default"].hide();
            if (_this4.state.onClose) {
              _this4.state.onClose();
            }
          }
        }))
      }), content)));
    }
  }]);
}(_react.Component);
;
Overlay.propTypes = {
  type: _propTypes["default"].oneOf(["default", "split"]),
  title: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
    middle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
    right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object])
  }), _propTypes["default"].shape({
    leftPanel: _propTypes["default"].shape({
      left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
      middle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
      right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object])
    }),
    rightPanel: _propTypes["default"].shape({
      left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
      middle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
      right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object])
    })
  })]),
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].shape({
    left: _propTypes["default"].any,
    right: _propTypes["default"].any
  })]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  closeText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onClose: _propTypes["default"].func
};
Overlay.defaultProps = {
  type: "default",
  display: false
};
var _default = exports["default"] = Overlay;